import {useState} from 'react'
import {Button} from '@/components/ui/button/Button'
import {ChevronDownIcon, ChevronUpIcon} from '@/components/ui/icon/Icon'
import {Menu, MenuGroup} from '@/components/ui/menu-atoms/MenuAtoms'
import {useTranslation} from '@/translations/i18n'
import {MenuButton, MenuProvider} from '@ariakit/react'
import {ObjectKeys} from '@/utilities/helpers'
import {useAgendaNavigation} from '@/features/agenda/hooks/useAgendaNavigation'
import {agendaViewMapToLabel} from '@/features/agenda/utils'
import {StyledAgendaViewMenuItem} from '@/features/agenda/components/agenda-view-menu/style'
import {useAgendaSearchParams} from '@/features/agenda/hooks/useAgendaSearchParams'

export const AgendaViewMenu = () => {
    const {t} = useTranslation()
    const [isOpen, setIsOpen] = useState(false)
    const {
        searchParams: {subjectIds, category, specializationIds}
    } = useAgendaSearchParams()

    const {
        params: {view},
        navigateToView
    } = useAgendaNavigation()

    if (!view) return null

    return (
        <MenuProvider open={isOpen} setOpen={setIsOpen}>
            <MenuButton
                render={
                    <Button
                        variant="secondary"
                        disabled={
                            !!(subjectIds && subjectIds?.length > 1) ||
                            (!!category && subjectIds && subjectIds?.length > 1) ||
                            (!!category && specializationIds && specializationIds?.length > 0) ||
                            (category == 'team' && !subjectIds)
                        }
                    >
                        {t(agendaViewMapToLabel[view])}
                        {isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
                    </Button>
                }
            />
            <Menu width="200px" onClick={event => event.stopPropagation()}>
                <MenuGroup>
                    {ObjectKeys(agendaViewMapToLabel).map(viewKey => (
                        <StyledAgendaViewMenuItem
                            key={viewKey}
                            $isActive={view == viewKey}
                            onClick={() => navigateToView(viewKey)}
                        >
                            {t(agendaViewMapToLabel[viewKey])}
                        </StyledAgendaViewMenuItem>
                    ))}
                </MenuGroup>
            </Menu>
        </MenuProvider>
    )
}
